<ngx-treeview
    [items]="configurableCategories"
    (selectedChange)="onSelect($event)"
    [config]="{ hasFilter: true, maxHeight: 250 }"
>
    Tree View
</ngx-treeview>